import React, { useState, useEffect } from 'react';
import { EventEmitter } from '../../events.js';
import { Col, Card, Divider, Form, Input, Select, DatePicker, Modal, Skeleton } from 'antd';
import Uploader from '../../components/misc/uploader';
import SavedCard from "../../components/savedCard";
import moment from 'moment';

import { useDispatch, useSelector } from 'react-redux';
import { setTemplateInfo, setcurrent, getCard, setCards } from "../../store/cards/cards.actions";

// Components
import Thumbnail from "../misc/Thumbnail";

// const { RangePicker } = DatePicker;
const { Option } = Select
const placeholder = require('../../assets/images/placeholder.png')

const Category = ({
    next=()=>{}
}) => {
    const [form] = Form.useForm();
    const { selected, eCards, campaigns, current } = useSelector(state => state.cards);
    const dispatch = useDispatch();
    const [visible, setvisible] = useState(false);
    const [promoImg, setpromoImg] = useState(null);
    const [ispromo, setispromo] = useState('');
    const [promotype, setpromotype] = useState('');
    const [ispromotype, setispromotype] = useState('');
    const [giveBack, setGiveBack] = useState('');

    const fetchAllCards = () => {
        dispatch(getCard({limit:'10',page: 1}))
        .then((response) => {
            console.log('All Cards:', response.data.data.cards);
            let draftedCards = response.data.data.cards.filter((el) => {
                let cardInfo = null;
                if (el.state === 'draft') {
                    cardInfo = Object.assign({}, el);
                    el.logo_position = el.web_design_props.logo_position

                    return cardInfo;
                }

                if (cardInfo !== null) return cardInfo;
            })

            // Set all draft cards here
            if (draftedCards.length > 0) {
                draftedCards.forEach(el => {
                    dispatch(setCards(el))
                });
            }
        })  
    };    

    const handlePromoStates = target => {
        setpromotype(target);
        dispatch(setTemplateInfo('promo_state', target));
        form.setFieldsValue({ promotion_state: target })
    };

    const handleIsPromo = (target) => {
        setispromo(target);
        dispatch(setTemplateInfo('is_promotion', target === 'yes' ? true : false));
    };

    const handlePromotionalType = (target) => {
        setispromotype(target);
        dispatch(setTemplateInfo('promo_type', target));
        form.setFieldsValue({ promotion_type: target })
    };

    const handleGiveBack = (target) => {
        setGiveBack(target);
        dispatch(setTemplateInfo('give_back_campaign_id', target));
        form.setFieldsValue({ giveBackCampaign: target });
    };

    const onFinish = async () => {
        try {
            if (selected.is_promotion) 
                await form.validateFields();
            else 
                await form.validateFields();

            dispatch(setcurrent(current + 1));
        } catch (errorInfo) {
            console.log('Failed:', errorInfo);
        } 
    };
    
    const handleInput = (val) => {
        if (Object.keys(val)[0] === "discount_value" || Object.keys(val)[0] === "special_promo" || Object.keys(val)[0] === "give_back" ) {
            dispatch(setTemplateInfo('promo_value', Object.values(val)[0]));
            
            console.log('Value Now!!', Object.values(val)[0]);
            // Set value on
            switch (Object.values(val)[0]) {
                case 'promotionDiscount':
                    form.setFieldsValue({ discount_value: Object.values(val)[0] });
                    break;
                case 'specialPromo':
                    form.setFieldsValue({ special_promo: Object.values(val)[0] });
                    break;
                case 'giveBack':
                    form.setFieldsValue({ give_back: Object.values(val)[0] });
                    break;
            
                default:
                    break;
            }            
        } else {
            dispatch(setTemplateInfo(Object.keys(val)[0], Object.values(val)[0]));
        }
    };    

    function onChange(dates, dateStrings, type) {
        console.log('dates', dates)
        console.log('dateGrings', dateStrings)
        dispatch(setTemplateInfo(type, dateStrings));
    };

    const getUploadedImage = (ImageURL) => {
        console.log('Uploaded Image:', ImageURL);
        // getBase64(e.file, (imageUrl) => {
        //     setpromoImg(imageUrl)
        //     setvisible(true);
        //     dispatch(setTemplateInfo('card_background', imageUrl));
        // });

        setpromoImg(ImageURL);
        setvisible(true);
        dispatch(setTemplateInfo('card_background', ImageURL));        

        // sendToBucket(e.file)
        // .then((response) => {
        //     console.log('card_background:', response.Location);
        //     setpromoImg(response.Location);
        //     setvisible(true);
        //     dispatch(setTemplateInfo('card_background', response.Location));
        // })
        // .catch(err => {
        //     console.log('Error:', err);
        // })        
    };

    const Ball = ({ color, size, target, onClick, disabled }) => {
        return (
            <div className={`${size ? `w-${size} h-${size}`: 'w-10 h-10'} rounded-full border border-black shadow-lg cursor-pointer flex--basic`}
                style={{
                    backgroundColor: `${target === ispromo || target === promotype || target === ispromotype || target === giveBack ? '#e7f8da' : color}`,
                }}
                onClick={onClick}
                disabled={disabled}
            >
                {(target === promotype || target === ispromo || target === ispromotype || target === giveBack) &&
                    <div className="rounded-full w-4 h-4 bg-primary" />
                }
            </div>
        )
    };

    const prefixSelector = (
        <Form.Item name="currency" noStyle>
          <Select defaultValue="ghs" className="currency text-sm" style={{ width: 60 }}>
            <Option value="ghs">GHS</Option>
            <Option value="usd">US$</Option>
          </Select>
        </Form.Item>
    );

    useEffect(() => {
        const newFormData = Object.assign({}, selected);

        if (newFormData.promotion_start) {
            newFormData.promotion_start = moment(newFormData.promotion_start, 'YYYY/MM/DD HH:mm:ss');
        }
        if (newFormData.expiry_date) {
            newFormData.expiry_date = moment(newFormData.expiry_date, 'YYYY/MM/DD HH:mm:ss');
        }

        if (newFormData.is_promotion) {
            setispromo('yes') 
        } else {
            setispromo('no')
        }

        if (newFormData.promo_type !== "noneSelected" || newFormData.promo_type !== null) {
            setispromotype(newFormData.promo_type);
        }

        if (newFormData.promo_state !== "stateNull" || newFormData.promo_state !== null) {
            setpromotype(newFormData.promo_state);
            newFormData.promotion_state = newFormData.promo_state
        }

        if (newFormData.give_back_campaign_id !== null) {
            setGiveBack(newFormData.give_back_campaign_id)
        }

        if (newFormData.promo_value) {
            switch (newFormData.promo_type) {
                case 'promotionDiscount':
                    newFormData.discount_value = newFormData.promo_value
                    break;
                case 'specialPromo':
                    newFormData.special_promo = newFormData.promo_value
                    break;
                case 'giveBack':
                    newFormData.give_back = newFormData.promo_value
                    break;
            
                default:
                    break;
            }

            newFormData.promotion_type = newFormData.promo_type
        }

        console.log('NewFormData:', newFormData);

        form.setFieldsValue(newFormData);
        console.log('Final Form Instance:', form.getFieldsValue());

    }, [selected, form]);

    useEffect(() => {
        if (selected.promo_type !== 'giveBack') {
            handleGiveBack("")
        }
        if (selected.promo_type !== 'specialPromo') {
            form.setFieldsValue({ special_promo: "" });
        }
        if (selected.promo_type !== 'promotionDiscount') {
            form.setFieldsValue({ discount_value: "" });
        }
    }, [ispromotype]);

    useEffect(() => {
        EventEmitter.subscribe('checkCategoryTemplate', () => {
            console.log('beforming checks for category template');
            onFinish()
        }) 
        
        // Set all draft cards and show them in draft list. Find a better implementation soon
        // fetchAllCards()
    }, [])

    return (
        <>
            <Col span={16} className="pt-4">
                <Card className="rounded-large shadow-lg">
                    <h2 className="text-xl font-bold text-center text-primary">Category</h2>
                    <div className="flex flex-col items-center w-full mx-auto relative">
                        {/* <img id="tempId" src={selected.image} className="w-1/2" alt="" /> */}

                        {/* <Image
                            preview={false}
                            className="w-1/2 rounded-lg"
                            src={selected.image}
                            placeholder={
                                // <Skeleton.Avatar className="w-full h-20" active={true} size="large" shape="square" />
                                <img src={placeholder} className="w-full h-full" alt="" />
                            }
                        /> */}
                            {selected.image ? 
                                <img 
                                    src={selected.image}
                                    className="w-1/2 rounded-lg object-cover shadow--perfect"
                                    style={{maxHeight: '12rem', minHeight: '12rem'}}
                                    alt=""
                                />                            
                            :
                                <Skeleton.Avatar className="w-full h-full" active={true} size="large" shape="square" />
                            }                        

                        <div className="absolute w-1/2 h-full">
                            {selected.show_amount &&
                                <div className="absolute top-0 right-0 p-4" 
                                    style={{
                                        color: `${selected.default_color}`,
                                        font_weight: `${selected.font_weight}`,
                                        fontSize: '1.0rem'
                                    }}>
                                        ¢{selected.amount}
                                </div>
                            }

                            {!selected.type &&
                                <div className={` ${selected.logo_position[0]}-0 ${selected?.logo_position[1]?.includes("flex--basic", "center") ? 'inset-y-0 flex--basic' : `${selected.logo_position[1]}-0`}  absolute p-4`}>
                                    {selected.logo?
                                        <img src={selected.logo} className="w-10 mx-auto" alt="" />
                                    :
                                        <div className="w-24 border-dashed border h-10 flex--basic" 
                                        style={{color: `${selected.default_color}`, borderColor: `${selected.default_color}`}}>
                                            Logo
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </div>     

                    <Divider className="border-black" />   

                    <Form
                        name="addPromo"
                        form={form}
                        className="w-full custom_card"
                        size="large"
                        layout="vertical"
                        onValuesChange={handleInput}
                    >

                        <div className="w-full flex">
                            <div className="w-full sm:w-3/12">
                                <div className="font-bold text-base pl-4">Promotion</div>
                                <div className="flex justify-around pt-8 mr-4">
                                    <div className="flex--basic pr-1">
                                        <Ball size="8"
                                            target="yes"
                                            onClick={() => { handleIsPromo('yes') }}
                                        />
                                        <div className="pl-1">Yes</div>
                                    </div>
                                    <div className="flex--basic">
                                        <Ball size="8"
                                            target="no"
                                            onClick={() => { handleIsPromo('no') }}
                                        />
                                        <div className="pl-1">No</div>
                                    </div>
                                </div>
                            </div>

                            {selected.is_promotion &&
                               <div className="w-full sm:w-4/12 flex flex-col">
                                    <Form.Item name="promotion_state" label="" className="w-full m-0 font-bold"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Please choose a promotion state",
                                            }
                                        ]}                                 
                                    >                            
                                        <div className="font-bold text-base text-center">What kind of Promotion</div>
                                        <div className="flex justify-around pt-8 mr-2">
                                            <div className="flex--basic">
                                                <Ball color="white" size="8"
                                                    target="open"
                                                    onClick={() => { 
                                                        handlePromoStates('open')
                                                    }}                                             
                                                />
                                                <span className="pl-2">Open</span>
                                            </div>
                                            <div className="flex--basic">
                                                <Ball color="white" size="8"
                                                    target="closed"
                                                    onClick={() => { 
                                                        handlePromoStates('closed')
                                                    }}                                             
                                                />
                                                <span className="pl-2">Closed</span>
                                            </div>

                                        </div>
                                        <div className="font-bold text-xs pt-4 text-left">
                                            <div>Open: <span className="text-xs font-normal"> Card can be used any time</span></div>
                                            <div>Close: <span className="text-xs font-normal"> Date/Event Restricted e-card</span></div>
                                        </div>
                                    </Form.Item>
                                </div>
                            }
                            
                            <div className="w-full sm:w-5/12 flex flex-col items-between">
                                <div className="font-bold text-base text-center">Background Image</div>
                                
                                <div className="flex--basic bg-cover bg-no-repeat mt-2 ml-4">
                                    <Uploader 
                                        disabled={ispromo === 'yes' ? false : true}
                                        uploadImage={getUploadedImage}
                                        classStyle={promoImg && "opacity-75 my-1 bg-cover bg-no-repeat w-full h-40"}
                                        bg={promoImg}
                                    />
                                    <Modal
                                        title="Card Promotion Background"
                                        visible={visible}
                                        style={{ top: 20 }}
                                        footer={null}
                                        onCancel={() => { setvisible(false)}}
                                    >
                                        <img src={promoImg} className="w-full" alt="" />
                                    </Modal>                                
                                </div>
                            </div>  
                        </div>

                        <Divider className="border-black" />

                        <div className="rounded-lg">
                            {selected.is_promotion &&
                                <>
                                    <section>
                                        <Form.Item name="promotion_type" label="" className="w-full m-0"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "Please select a promotion type",
                                                }
                                            ]}                                 
                                        >
                                            <div className="font-bold text-base pb-4">
                                                Promotional Type
                                                <div className="text-xs font-normal">Please select the promotional type and continue</div>
                                            </div>
                                            <section className="flex w-full">
                                                <div className="border-r border-primary pr-2 w-3/12">
                                                    <div className="flex items-center">
                                                        <Ball color="white" size="8"
                                                            target="promotionDiscount"
                                                            onClick={() => { handlePromotionalType('promotionDiscount')}}                                             
                                                        />
                                                        <span className="pl-2">Discount</span>
                                                    </div> 
                                                    <Form.Item label="" className="font-bold">
                                                        <div className="text-xs leading-snug pt-3">Discounted Amount</div>
                                                        <Form.Item name="discount_value" label="" className="m-0 w-full"
                                                            rules={[
                                                                {
                                                                    required: ispromotype === 'promotionDiscount' ? true : false,
                                                                    message: "Please select a promotion type",
                                                                }
                                                            ]}                                                          
                                                        >
                                                            <Input
                                                                placeholder="Discount" 
                                                                addonBefore={prefixSelector}
                                                                // onChange={(e) => { form.setFieldsValue({ discount_value: e.target.value }) }}
                                                                size="middle" 
                                                                className="mt-2 rounded bg-white" 
                                                            />
                                                        </Form.Item>

                                                        <div className="pt-3 tracking-snug tracking-tight text-xs font-normal">
                                                            <div className="font-bold">NB: Amount you enter here is what customers will pay for this card.</div>
                                                            <div>Also make sure to add terms and condition to your discount promo below.</div>
                                                        </div>
                                                    </Form.Item>
                                                </div>
                                                <div className="border-r border-primary px-2 w-3/12">
                                                    <div className="flex items-center">
                                                        <Ball color="white" size="8"
                                                            target="specialPromo"
                                                            onClick={() => { handlePromotionalType('specialPromo')}}                                             
                                                        />
                                                        <span className="pl-2">Special Promos</span>
                                                    </div> 
                                                    <Form.Item 
                                                        name="special_promo" 
                                                        label={<div className="text-xs leading-snug">Name</div>} 
                                                        className="font-bold mb-2"
                                                        rules={[
                                                            {
                                                                required: ispromotype === 'specialPromo' ? true : false,
                                                                message: "Please select a promotion type",
                                                            }
                                                        ]}                                                      
                                                    >
                                                        <Input
                                                            rows={2}
                                                            placeholder="Promo text" 
                                                            size="middle"
                                                            className="mt-2 rounded bg-white border border-primary" 
                                                        />
                                                    </Form.Item>
                                                    <div className="pt-3 tracking-snug tracking-tight text-xs font-normal">
                                                        Make sure to add information
                                                        about the special promotion in
                                                        the description box below.
                                                    </div>
                                                </div>
                                                <div className="pl-2 w-6/12">
                                                    <div className="flex items-center">
                                                        <Ball color="white" size="8"
                                                            target="giveBack"
                                                            onClick={() => { handlePromotionalType('giveBack')}}                                             
                                                        />
                                                        <span className="pl-2">Give Back Promos</span>
                                                    </div>
                                                    
                                                    <div className="py-2 text-xs tracking-tight font-normal">
                                                        Please select any of the Give Back programs you would like to support and continue
                                                    </div>

                                                    <Form.Item name="giveBackCampaign" label="" className="pt-3 mb-2"
                                                        rules={[
                                                            {
                                                                required: ispromotype === 'giveBack' ? true : false,
                                                                message: "Please select a give back campaign",
                                                            }
                                                        ]}                                                    
                                                    >                                
                                                    {campaigns.length > 0 ?
                                                        <section className="w-full flex">
                                                            {campaigns?.slice(0,3).map((campaign, index) => (
                                                                <div className="w-full sm:w-1/3 flex flex-col items-center pr-2" key={index}>
                                                                    <Thumbnail 
                                                                        background="bg-gray-300" 
                                                                        bgType={campaign.images?.length > 0 ? campaign.images[0].url : placeholder}  
                                                                    />
                                                                    <div className="text-center text-xs font-bold pb-1">{campaign.name}</div>
                                                                    <Ball color="white" size="8"
                                                                        target={campaign.id}
                                                                        onClick={() => { handleGiveBack(campaign.id)}}                                             
                                                                    />                                                
                                                                </div>
                                                            ))}
                                                        </section>
                                                    :
                                                        <div className="bg-white p-2 w-full text-center text-primary">No Campaign Available</div>
                                                    }                    
                                                    </Form.Item>
                                                    
                                                    <Form.Item label="" className="pt-3">
                                                        <div className="w-full text-xs leading-snug flex items-start justify-between">
                                                            <div className="w-1/2">Enter amount you are donating from a sale:</div>
                                                            <Form.Item name="give_back" className="m-0 w-1/2"
                                                                rules={[
                                                                    {
                                                                        required: giveBack ? true : false,
                                                                        message: "Please provide amount for this giveback campaign",
                                                                    }
                                                                ]}                                                            
                                                            >
                                                                <Input 
                                                                    addonBefore={prefixSelector}
                                                                    placeholder="Donating Amount" 
                                                                    size="middle" 
                                                                    className="border-none w-full ml-2 rounded bg-white border border-primary" 
                                                                />
                                                            </Form.Item>
                                                        </div>
                                                    </Form.Item>
                                                </div>
                                            </section>
                                        </Form.Item>

                                        <div className="py-6 pb-2 text-center tracking-tighter text-sm border-b border-gray-500">
                                            <span className="font-semibold">Note: </span>
                                            <span>This promotional card will attract 1% one time fee on each card redeemed by the customer.</span>
                                        </div>
                                    </section>

                                    <Form.Item name="promotion_title" label="Promo Title" className="font-bold text-left pb-2"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Kindly provide promo title",
                                            }
                                        ]}
                                    >
                                        {/* <label className=" mb-2"></label> */}
                                        <Input placeholder="" className="rounded bg-white mt-2 border border-primary text-sm" />
                                    </Form.Item>

                                    {selected.promo_state === "closed" &&
                                        <div className="flex">
                                            <Form.Item name="promotion_start" label="Start Date" className="w-1/2 font-bold text-base text-center">
                                                <DatePicker 
                                                    className="w-full mr-2 rounded"
                                                    // showTime
                                                    format="YYYY/MM/DD HH:mm:ss"
                                                    onChange={(e,y) => {onChange(e, y, 'promotion_start')}}
                                                />
                                            </Form.Item>
                                            <Form.Item name="expiry_date" label="End Date" className="w-1/2 font-bold text-base text-center">
                                                <DatePicker 
                                                    className="w-full ml-2 rounded"
                                                    // showTime
                                                    format="YYYY/MM/DD HH:mm:ss"
                                                    onChange={(e,y) => {onChange(e, y, 'expiry_date')}}
                                                />
                                            </Form.Item>
                                        </div>
                                    }

                                    <Divider className="border-black" /> 
                                </>
                            }               

                            <Form.Item name="description" label="Description" className="font-bold text-left"
                            rules={[
                                {
                                    required: true,
                                    message: "Kindly provide card description",
                                }
                            ]}
                            >
                                <Input.TextArea rows={4} placeholder="" className="rounded mt-2 bg-white text-sm" />
                            </Form.Item>

                            {selected.is_promotion &&
                                <Form.Item name="promotion_terms" label="Terms and Conditions" className="font-bold text-left">
                                    <Input.TextArea rows={4} placeholder="" className="rounded mt-2 bg-white text-sm" />
                                </Form.Item>
                            }
                        </div>
                    </Form>
                </Card>
            </Col>
            <Col span={8} className="pt-4 pl-4">
                <Card
                    title="Drafted e-gift cards"
                    extra={<span className="font-bold text-xl">{eCards.length}</span>}
                    className="saved--cards rounded-large shadow-lg text-primary"
                    style={{minHeight: '50vh'}}
                >
                    {eCards.length <= 0 ?
                        <div className="flex--basic pt-10">
                            <div>
                                <svg className="fill-current mx-auto w-20 h-20" width="64" height="64" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0)">
                                <path d="M510.244 143.201C508.039 138.251 504.041 134.463 498.984 132.536L288.653 52.3913C280.875 49.4256 272.363 51.5884 266.889 57.1949L262.089 30.1713C260.146 19.2352 249.632 11.9039 238.654 13.8227L93.7357 39.1885C89.656 39.9024 86.9272 43.7891 87.6412 47.8687C88.3551 51.9474 92.2408 54.6741 96.3214 53.9632L241.239 28.5974C244.044 28.1095 246.83 30.0293 247.321 32.7941L255.904 81.1128L235.014 135.135L225.584 81.3958C224.246 72.7725 215.854 65.7952 207.191 67.464L64.7162 92.7708C56.2129 94.2827 50.6044 102.972 52.2143 112.141L97.1903 368.439C98.5382 377.064 106.899 384.034 115.584 382.37L141.166 377.827L136.104 390.919C133.207 398.133 135.084 406.854 140.592 412.313L82.4586 422.488C79.6509 422.976 76.8681 421.056 76.3762 418.291L15.1146 73.4125C14.5746 70.6987 16.6314 67.848 19.3632 67.434L60.3256 60.2636C64.4062 59.5497 67.134 55.663 66.4201 51.5834C65.7061 47.5038 61.8134 44.779 57.7398 45.4889L16.7784 52.6593C6.06235 54.3002 -1.77196 65.4002 0.346851 76.0353L61.6085 420.913C63.5003 431.913 74.3234 439.218 85.0434 437.262L164.449 423.363L358.092 497.148C368.223 501.092 380.219 496.017 384.214 485.563L486.635 220.705C488.129 216.842 486.208 212.499 482.345 211.005C478.482 209.512 474.139 211.432 472.646 215.295L370.225 480.154C369.208 482.784 366.1 484.153 363.434 483.132L153.101 402.987C150.503 402.064 149.043 398.881 150.093 396.327L159.67 371.56C159.927 371.067 160.129 370.546 160.272 370.003L204.086 256.701C205.58 252.839 203.659 248.496 199.796 247.002C195.933 245.509 191.591 247.43 190.097 251.292L147.492 361.468L113.038 367.588C112.765 367.481 112.147 366.895 111.963 365.846L66.987 109.548C66.8 108.486 67.191 107.718 67.416 107.525L209.736 82.2467C210.009 82.3537 210.627 82.9397 210.811 83.9886L224.54 162.223L203.243 217.297C201.749 221.159 203.67 225.502 207.533 226.996C211.296 228.481 215.741 226.607 217.232 222.706L269.816 86.7233C270.561 85.6914 271.043 84.4725 271.189 83.1736L276.521 69.3858C277.538 66.7551 280.647 65.3892 283.312 66.4071L493.644 146.553C496.243 147.477 497.703 150.658 496.654 153.212L485.793 181.299C484.299 185.162 486.22 189.504 490.083 190.998C493.944 192.487 498.288 190.571 499.782 186.709L510.643 158.622C512.581 153.608 512.44 148.133 510.244 143.201V143.201Z" fill="#A2A2B5"/>
                                <path d="M390.227 220.701C372.303 212.413 355.098 216.503 345.131 220.461C341.072 211.408 332.465 198.053 315.503 191.512C310.327 189.516 292.028 183.742 273.844 193.241V193.242C254.581 203.302 249.107 223.389 246.768 231.968C232.394 284.698 287.834 339.093 294.203 345.122C295.597 346.442 297.443 347.176 299.358 347.176C299.411 347.176 299.464 347.175 299.517 347.174C314.493 346.858 390.333 342.826 412.722 294.48C415.97 287.467 424.597 268.837 417.174 248.922C410.768 231.735 396.196 223.46 390.227 220.701V220.701ZM399.113 288.177C381.578 326.04 318.572 331.335 302.299 332.071C291.121 320.927 250.147 276.605 261.24 235.911C263.218 228.657 267.331 213.563 280.788 206.535C293.72 199.783 307.48 204.493 310.107 205.507C327.962 212.391 333.107 230.601 333.636 232.654C334.716 237.37 340.598 239.812 344.699 237.252C346.753 236.045 365.306 225.704 383.933 234.315C388.217 236.294 398.66 242.194 403.12 254.16C408.358 268.213 402.113 281.695 399.113 288.177V288.177Z" fill="#A2A2B5"/>
                                </g>
                                <defs>
                                <clipPath id="clip0">
                                <rect width="512" height="512" fill="white"/>
                                </clipPath>
                                </defs>
                                </svg>
                                <div className="font-normal">
                                    No Cards Available
                                </div>

                            </div>
                        </div>
                    :
                        <div className="w-full">
                            {eCards.map((card, index) => (
                                <div className="flex flex-col">
                                    <SavedCard card={card} key={index} />
                                    <Divider className="border-black" />
                                </div>
                            ))}
                        </div>  
                    }
                </Card>
                {selected.is_promotion &&
                    <div className="pt-10">
                        <img src={require("../../assets/images/in-app-promo.png")} 
                            className="w-full"
                            alt="" 
                        />
                    </div>
                }
            </Col>
        </>        
    )
};

export default Category;